<template>
  <div class="header-section">
    <div class="slogan" :class="curLang"></div>
    <div class="top-container" v-if="!isMobile">
      <div class="game-logo"></div>
      <LangSwitcher class="header-lang-switcher" />
    </div>
    <div class="center-container">
      <div class="login-module">
        <div v-if="isLogin" class="user-info">
          <div class="info">
            <span class="avatar"></span>
            <span class="username">{{ accountName }}</span>
          </div>
          <div class="logout-btn" @click="logout()">
            {{ langData.logoutBtn }}
          </div>
        </div>
        <div v-else class="login-btn btns" @click="gotoLogin()">
          <span class="login-user-icon"></span>
          <span class="login-text">{{ langData.loginBtn }}</span>
        </div>
        <div class="feedback-btn btns" @click="showFeedbackPopup">
          <span class="submit-feedback">{{ langData.feedback }}</span>
        </div>
        <div
          class="participant-count"
          v-html="
            getReplaceText(langData.joinActivityText, participantCount || 0)
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { getReplaceText } from "@/utils";
import LanguageHook from "@/hooks/language";
import LangSwitcher from "@/components/LangSwitcher.vue";

// 语言相关
const { langData, curLang } = LanguageHook();

// 注入的数据
const isLogin = inject("isLogin");
const accountName = inject("accountName");
const isMobile = inject("isMobile");
const participantCount = inject("participantCount", 0);
const checkLogin = inject("checkLogin", () => {});

// Props & Emits
const emit = defineEmits(["gotoLogin", "logout", "showFeedbackPopup"]);

// 方法
const showFeedbackPopup = () => {
  if (!checkLogin()) return;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "反馈按钮",
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  window.activityDataLayer.push({
    eventName: "show_popup",
    eventType: "反馈弹窗",
    aid: window.activity_name,
    gameId: window.game_id,
  });
  emit("showFeedbackPopup");
};

const gotoLogin = () => {
  emit("gotoLogin");
};

const logout = () => {
  emit("logout");
};
</script>
